export default "/_next/static/videos/fcf960378312e9f457c012ff2119c109.mp4";